import { lumi } from '../lib/lumi'

export interface EventForInvitation {
  _id: string
  title: string
  titleFr?: string
  description?: string
  descriptionFr?: string
  image?: string
  location?: string
  address?: string
  city?: string
  country?: string
  startDate?: string
  endDate?: string
  vernissageDate?: string
  vernissageTime?: string
  openingHours?: string
}

export interface InviteeForResend {
  firstName: string
  lastName: string
  email: string
  country: string
  language?: 'fr' | 'en'
  attendingVernissage?: boolean
  confirmationToken?: string
  newsletterOptIn?: boolean
}

const getLocalizedTitle = (ev: EventForInvitation, lang: 'fr' | 'en'): string =>
  lang === 'fr' && ev.titleFr && ev.titleFr.trim() ? ev.titleFr : ev.title

const getLocalizedDescription = (ev: EventForInvitation, lang: 'fr' | 'en'): string =>
  lang === 'fr' && ev.descriptionFr && ev.descriptionFr.trim() ? ev.descriptionFr : (ev.description || '')

// Renvoie l'e-mail d'invitation (via la fonction Deno sendEventInvitation) a un contact deja
// enregistre, en reconstruisant le contenu a partir des donnees actuelles de l'exposition
// (titre, description, dates, lieu...) et de la langue choisie par ce contact.
export async function resendInvitationEmail(event: EventForInvitation, invitee: InviteeForResend) {
  const lang: 'fr' | 'en' = invitee.language === 'en' ? 'en' : 'fr'
  const fullLocation = [event.location, event.address, event.city, event.country]
    .filter(Boolean)
    .join(', ')

  return lumi.functions.invoke('sendEventInvitation', {
    method: 'POST',
    body: {
      eventId: event._id,
      eventTitle: getLocalizedTitle(event, lang),
      eventDescription: getLocalizedDescription(event, lang),
      eventImage: event.image || '',
      location: fullLocation,
      startDate: event.vernissageDate || event.startDate || '',
      endDate: event.endDate || event.startDate || '',
      openingHours: event.openingHours || '',
      vernissageTime: event.vernissageTime || '',
      firstName: invitee.firstName,
      lastName: invitee.lastName,
      email: invitee.email,
      country: invitee.country,
      language: lang,
      attendingVernissage: invitee.attendingVernissage || false,
      confirmationToken: invitee.confirmationToken || '',
      newsletterOptIn: invitee.newsletterOptIn === true,
    },
  })
}
